import { Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, Renderer2 } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { BlogDetailModel } from "src/app/models/blog-detail.model";
import { LanguageService } from "src/app/services";
import { BlogService } from "src/app/services/blog.service";
import { translateToEnglish } from "src/app/shared/helpers/string.utils";
import { environment } from "src/environments/environment";
import { CONFIG } from "../../core/config/config";
import { LoadingService } from "../../shared/services/loading.service";
import { isPlatformBrowser } from "@angular/common";
import Swiper, { SwiperOptions, Navigation } from "swiper";
import { NavigationOptions } from "swiper/types/components/navigation";
import { PaginationOptions } from "swiper/types/components/pagination";
import { DoctorService } from "../../services/doctor.service";
import { SearchService } from "../../services/search.service";
import { InsuranceService } from "src/app/shared/services/insurance.service";

Swiper.use([Navigation])
@Component({
  selector: "app-blog-detail-new-page",
  templateUrl: "./blog-detail-new-page.component.html",
  styleUrls: ["./blog-detail-new-page.component.scss"],
})
export class BlogDetailNewPageComponent implements OnInit {
  public cLang = CONFIG.LANGS.LANG_DATA.DEFAULT_LANG;
  public blogData: any;
  public allBlogs: any[] = [];
  public url = environment.apiUrl;
  public baseUrl = environment.baseUrl;
  public blogId: number;
  public blogName: string;
  public selectedBlog: BlogDetailModel;
  public newBlogs: any[] = [];
  blogDataAvailable = false;
  isLastBlogPage = false;
  currentPage = 0;
  public popularBlogNav: NavigationOptions = {
    nextEl: '.blog .new-next',
    prevEl: '.blog .new-prev'
  };
  public popularBlogPagination: PaginationOptions = {
    el: '.blog .pagination'
  };
  public popularBlogConfig: SwiperOptions = {
    direction: 'horizontal',
    slidesPerView: 3,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: this.popularBlogNav,
    pagination: this.popularBlogPagination,
    spaceBetween: 15,
    breakpoints: {
      992: {
        slidesPerView: 3
      },
      576: {
        slidesPerView: 2
      },
      320: {
        slidesPerView: 1
      }
    }
  };

  // /* popular doctors swiper configs */
  public popularDoctorsNav: NavigationOptions = {
    nextEl: ".popular-doctors .new-next",
    prevEl: ".popular-doctors .new-prev",
  };
  public popularDoctorsPagination: PaginationOptions = {
    el: ".popular-doctors .pagination",
  };
  public popularDoctorsConfig: SwiperOptions = {
    direction: "horizontal",
    slidesPerView: 3,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: this.popularDoctorsNav,
    pagination: this.popularDoctorsPagination,
    spaceBetween: 15,
    breakpoints: {
      992: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 1,
      },
      320: {
        slidesPerView: 1,
      },
    },
    autoplay: {
      delay: 3000,
    },
  };
  doctorsList = [];
  public selectedLanguage = localStorage.getItem('CurLang') || 'ka';

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private _languageService: LanguageService,
    private loadingService: LoadingService,
    private _blogService: BlogService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _title: Title,
    private _meta: Meta,
    private doctorService: DoctorService,
    private searchService: SearchService,
    private renderer: Renderer2,
    private element: ElementRef,
    private insuranceService: InsuranceService,
    
  ) {this.getAllNewBlogs();}
  isDesktop: boolean = true;
  isMobile: boolean = false;
  
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkScreenSize();
  }
  


  checkScreenSize(): void {
    this.isDesktop = window.innerWidth > 768; // Adjust the threshold according to your design breakpoints
    this.isMobile = window.innerWidth < 576;
  }

  ngOnInit() {
    this.checkScreenSize();
    this._route.params.subscribe((result) => {
      if (!result.blogName) {
        this.loadingService.setApplicationLoading(true);
        this._blogService.getBlog(result.id).subscribe((res) => {
          console.log(res);
          this._router.navigate([
            `/blog-new/${translateToEnglish(
              res?.title.replace(/ - /g, "-").replace(/ /g, "-")
            )}/${res?.id}`,
          ]);
        });
      } else {
        this.blogId = result.id;
        const doctorIds = this.blogData?.doctorIds.map((e) => e.doctorId);
        if (doctorIds?.length) {
          this.doctorService.getPopularDoctors().subscribe((res) => {
            this.doctorsList = res.result.filter((e) =>
              doctorIds.includes(e.doctorId)
            );
          });
        }
        if (this.blogData?.specialityId) {
          this.doctorService.getPopularDoctors().subscribe((res) => {
            this.doctorsList = res.result.filter((e) =>
              e.speciality.find(
                (b) => b.specialityId === this.blogData.specialityId
              )
            );
          });
        }
        this.getBlog(this.blogId);
        this.getAllBlog();
      }
      (error) => {
        console.log(error.error);
      };
    });
  }

  getBlog(blogId: number): void {
    this._blogService.getBlog(blogId).subscribe(
      (result) => {
        this.blogData = result;
        const doctorIds = this.blogData.doctorIds.map((e) => e.doctorId);
        if (this.blogData.specialityId) {
          this.searchService
            .searchForDoctors(
              `ServiceTypeId=1&SpecialityId=${this.blogData.specialityId}`
            )
            .subscribe((res) => {
              this.doctorsList = res.content;
            });
        } else if (doctorIds.length) {
          doctorIds.forEach((doctorId) => {
            this.searchService
              .searchForDoctors(`ServiceTypeId=1&doctor-id=${doctorId}`)
              .subscribe((res) => {
                this.doctorsList.push(res.content[0]);
              });
          });
        }
        this._title.setTitle(this.blogData.title + " - REDMED");
        this._meta.updateTag({
          property: "og:url",
          content: `${this.baseUrl}/blog-new/${translateToEnglish(
            this.blogData.title.replace(/ - /g, "-").replace(/ /g, "-")
          )}/${this.blogId}`,
        });
        this._meta.updateTag({ property: "og:type", content: "article" });
        this._meta.updateTag({
          property: "og:title",
          content: this.blogData.title,
        });
        this._meta.updateTag({
          property: "og:description",
          content: this.stripHtml(this.blogData.fullText).substr(0, 200),
        });
        this._meta.updateTag({
          property: "description",
          content: this.stripHtml(this.blogData.fullText).substr(0, 200),
        });
        this._meta.updateTag({
          name: "description",
          content: this.stripHtml(this.blogData.fullText).substr(0, 200),
        });
        this._meta.updateTag({
          property: "og:image",
          content: `${this.url}/blog/image/${this.blogData.img}`,
        });
        this._meta.updateTag({
          property: "og:image:width",
          content: "1200", // Set your desired width
        });
        this._meta.updateTag({
          property: "og:image:height",
          content: "630", // Set your desired height
        });
      },
      (error) => {
        console.log(error.error);
      }
    );
  }

  getAllBlog(): void {
    this.loadingService.setApplicationLoading(true);
    this._blogService.getAllBlog(6, this.currentPage).subscribe(
      (result) => {
        if (result) {
          result.content.forEach((blog) => {
            this.allBlogs.push(blog);
          });
          if (result.last) {
            this.isLastBlogPage = true;
            this.loadingService.setApplicationLoading(false);
            return;
          }
          this.loadingService.setApplicationLoading(false);
        }
      },
      (error) => {
        this.loadingService.setApplicationLoading(false);
        console.log(error.error);
      }
    );
  }

  getMoreBlogs() {
    this.currentPage++;
    this.getAllBlog();
  }

  goToNewBlog(blog: BlogDetailModel) {
    this._router.navigate([
      `/blog-new/${translateToEnglish(
        blog.title.replace(/ - /g, "-").replace(/ /g, "-")
      )}/${blog.id}`,
    ]);
  }

  stripHtml(html): string {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }

  copyBlogUrl() {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = `${this.baseUrl}/blog-new/${translateToEnglish(
      this.blogData.title.replace(/ - /g, "-").replace(/ /g, "-")
    )}/${this.blogId}`;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }

  getBlotTitle() {
    return translateToEnglish(
      this.blogData.title.replace(/ - /g, "-").replace(/ /g, "-")
    );
  }

  translateToEnglish(s: string) {
    return translateToEnglish(s);
  }


  navigateToDoctorProfile(doctor: any) {
    const translatedName = this.translateToEnglish(doctor.fullName.replace(' ', '-'));
    const clinicId = doctor.clinic ? '/' + doctor.clinic.id : '';
    const url = `/eqimi/${translatedName}/${doctor.userId}${clinicId}`;
    const queryParams = {
      insurance: false,
      selectedSpeciality: doctor.specialties[0].specialtyId,
      selectedServiceType: 1,
    };
    this._router.navigate([url],{ queryParams: queryParams });
  }

  onInsuranceProviderDoctorBubbleClick(): void {
    this.insuranceService.insuranceProviderDoctorBubbleLogic(this.selectedLanguage);
  }

  fixedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
      return '%' + c.charCodeAt(0).toString(16);
    });
  }

  goToClinicWeb(lab?: string) {
    if (isPlatformBrowser(this.platformId)) {
      if (lab) {
        let url = `https://clinic${environment.production ? '' : 'stage'}.redmed.ge/auth?token=${this.fixedEncodeURIComponent(localStorage.getItem('UserAccessToken'))}&page=&step=search&selector=lab&selectedLanguage=${this.selectedLanguage}`;
        if (lab === 'lab-home') {
          url += '&test-type-id=1';
        }
        window.open(url);
        return;
      }
      if (localStorage.getItem('UserAccessToken')) {
        window.open(`https://clinic${environment.production ? '' : 'stage'}.redmed.ge/auth?token=${this.fixedEncodeURIComponent(localStorage.getItem('UserAccessToken'))}&selectedLanguage=${this.selectedLanguage}`);
        return;
      }
    }
    window.open(`https://clinic${environment.production ? '' : 'stage'}.redmed.ge?selectedLanguage=${this.selectedLanguage}`);
  }

  goToNurseAtHome(){
    window.open(`https://clinic${environment.production ? '' : 'stage'}.redmed.ge/auth?token=${this.fixedEncodeURIComponent(localStorage.getItem('UserAccessToken'))}&page=&step=search&selector=nurse&selectedLanguage=${this.selectedLanguage}`);

  }

  private getAllNewBlogs(): void {
    this._blogService.getAllBlog(5).subscribe(
      result => {
        this.newBlogs = result.content;
        this.blogDataAvailable = true;
      },
      error => {
        console.log(error.error);
      });
  }

}
